module.exports = __webpack_public_path__ + "img/icone-revisao.4f78be7b.svg";